import { frontendURL } from 'dashboard/helper/URLHelper';

const MedicalRecords = () => import('./pages/MedicalRecords.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/medical-records'),
    name: 'medical_records',
    component: MedicalRecords,
    meta: {
      permissions: ['doctor'],
    },
  },
  {
    path: frontendURL(
      'accounts/:accountId/contacts/:contactId/patients/:patientId/medical-records/:medicalRecordId'
    ),
    name: 'new_medical_record',
    component: () => import('./pages/NewMedicalRecord.vue'),
    props: route => ({
      accountId: route.params.accountId,
      patientId: route.params.patientId,
      medicalRecordId: route.params.medicalRecordId,
    }),
    meta: {
      permissions: ['doctor'],
    },
  },
];
